import { useRef } from 'react'
import styles from './voice.module.css'

type Props = {
  peaks: readonly number[]
  progress: number
  bars?: number
  onSeek?: (fraction: number) => void
  className?: string
}

export function resamplePeaks(peaks: readonly number[], bars: number): number[] {
  if (peaks.length === 0) return Array.from({ length: bars }, () => 20)
  return Array.from({ length: bars }, (_, i) => peaks[Math.floor((i / bars) * peaks.length)] ?? 20)
}

export function VoiceWave({ peaks, progress, bars = 40, onSeek, className }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const values = resamplePeaks(peaks, bars)
  const played = Math.round(progress * bars)
  const seekAt = (clientX: number) => {
    const rect = ref.current?.getBoundingClientRect()
    if (!rect || !onSeek || rect.width === 0) return
    onSeek(Math.min(1, Math.max(0, (clientX - rect.left) / rect.width)))
  }
  return (
    <div
      ref={ref}
      className={`${styles.wave} ${className ?? ''}`}
      onPointerDown={onSeek ? (e) => seekAt(e.clientX) : undefined}
      aria-hidden="true"
    >
      {values.map((v, i) => (
        <i key={i} className={i < played ? styles.played : undefined} style={{ height: `${Math.max(8, v)}%` }} />
      ))}
    </div>
  )
}
